<!--
* @Name：定价方式审批基本页面
* @Author: 王超
* @Date: 2025-09-16 10:39:49
* @Last Modified by: 王超
* @Last Modified time: 2025-09-16 10:39:49
-->
<template>
  <div class="approval-container">
    <van-nav-bar title="定价方式审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="baseInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">基本信息</span>
        </template>
        <base-info :head-info="headInfo" />
      </van-collapse-item>
      <van-collapse-item name="materialDetails">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">物料信息明细</span>
        </template>
        <material-details :detailsList="headInfo.matList" />
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批意见</span>
        </template>
        <hi-flow-approval />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { pmPriceModeCreateHead } from '@/api/pmPriceModeApply'
import Bridge from '@/components/dsbridge'
export default {
  name: 'PmPriceModeApproval',
  components: {
    'base-info': () => import('./components/BaseInfo.vue'),
    'material-details': () => import('./components/MaterialDetails.vue')
  },
  data() {
    return {
      activeNames: ['baseInfo', 'approvalOpinions'],
      headInfo: {},
      pmPriceModeCreateHeadId: this.$route.query.businessKey
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    async initData() {
      const headResp = await pmPriceModeCreateHead(this.pmPriceModeCreateHeadId)
      this.headInfo = headResp.data
    },
    onClickLeft() {
      Bridge.callMethodSyn('app.jsLeavePage', '')
    }
  }
}
</script>
<style lang="scss" scoped>
.title-class {
  background-color: #eee;
}
</style>
